import { render, staticRenderFns } from "./item-category.vue?vue&type=template&id=642ee9ab&"
import script from "./item-category.vue?vue&type=script&lang=js&"
export * from "./item-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports